import { render, staticRenderFns } from "./CarrierServiceLevelsList.vue?vue&type=template&id=383f7cdd&scoped=true&"
import script from "./CarrierServiceLevelsList.vue?vue&type=script&lang=js&"
export * from "./CarrierServiceLevelsList.vue?vue&type=script&lang=js&"
import style0 from "./CarrierServiceLevelsList.vue?vue&type=style&index=0&id=383f7cdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383f7cdd",
  null
  
)

export default component.exports